import type { UserData } from "../types";

const user: UserData = {
  name: "Louis",
  avatar: "img/ui/avatar.jpg",
  password: "201314abc"
};

export default user;
